import { useState, useEffect } from 'react'
import { buildStocks } from '../data/seed.js'
import { supabase } from '../lib/supabase.js'


const RAW_SEED=[{"sku":"PPA72","name":"Midea Panela De Pressao Eletrica 6l 220v","price":365.5,"stock":9},{"sku":"KM5221W","name":"Teclado E Mouse Sem Fio Dell Pro Km5221w","price":229.0,"stock":48},{"sku":"CMM15P2","name":"Cafeteira Eletrica Midea 1,5l 220v","price":153.4,"stock":5},{"sku":"210-BHYN-008L","name":"Microcomputador Dell Inspiron 15 3530","price":3906.41,"stock":3},{"sku":"210-BRNS-00HL","name":"Microcomputador Dell Pro 16 Pc16250","price":7692.43,"stock":3},{"sku":"MD-RT411FGF012","name":"Geladeira Duplex 294l Midea Branca","price":2399.0,"stock":8},{"sku":"WM118BK","name":"Mouse Dell Wm118 Bluetooth","price":94.53,"stock":10},{"sku":"15120190","name":"Camera Ip Bullet Vip 1220 Full Color G4","price":472.86,"stock":12},{"sku":"JDD2580TW","name":"Purificador Agua Slim Branco","price":539.34,"stock":2},{"sku":"15110135","name":"Tablet Lenovo Tab K11 4gb 128gb","price":1496.6,"stock":3},{"sku":"MRAS22","name":"Forno Micro-ondas 20l 220v","price":14.0,"stock":4},{"sku":"CMD15P2","name":"Midea Cafeteira Digital 1,5l 220v","price":207.14,"stock":4},{"sku":"15110194","name":"Tv LG 50 Tela Cristal Liquido","price":2519.86,"stock":1},{"sku":"210-BLVS-VH8Q","name":"Dell Optiplex 7020 i7 32gb Ssd 512","price":3497.2,"stock":4},{"sku":"15110129","name":"Forno Eletrico Hq 48 Litros 1600w","price":306.0,"stock":13},{"sku":"MK200","name":"Combo Teclado Mouse Logitech Mk200","price":152.07,"stock":1},{"sku":"MRC06B2-B","name":"Frigobar Preto 45l 220v","price":168.0,"stock":2},{"sku":"CMM15P1","name":"Cafeteira Midea 1,5l 127v","price":153.42,"stock":20},{"sku":"MXSA35B1","name":"Micro-ondas 35l Midea Branco 110v","price":842.47,"stock":15},{"sku":"83NS0001BR","name":"Notebook Lenovo Ideapad Slim 3 I5 16gb 512gb","price":5397.0,"stock":50},{"sku":"210-BQTT-00PQ","name":"Mini Computador Dell Pro Micro I5-14500t","price":4999.0,"stock":3},{"sku":"KF556C40BB-32","name":"Memoria Ram Kingston Fury Beast 32gb Ddr5","price":3080.0,"stock":6},{"sku":"RM-D3-8G1600VL","name":"Memoria Ram Ddr3 8gb 1600mhz Rise Mode","price":223.52,"stock":10},{"sku":"210-BHYN-T9YH","name":"Notebook Dell Inspiron 15 I5 8gb 512gb","price":4390.0,"stock":20},{"sku":"MK220","name":"Kit Teclado E Mouse Logitech Mk220","price":172.45,"stock":5},{"sku":"580-BCZQ","name":"Kit Teclado E Mouse Dell Km300c","price":134.11,"stock":10},{"sku":"MK540","name":"Combo Teclado Mouse Logitech Mk540","price":334.59,"stock":7},{"sku":"K120","name":"Teclado Logitech K120 Preto","price":91.0,"stock":34},{"sku":"SE2225HM","name":"Monitor Dell 22 Se2225hm","price":729.0,"stock":1},{"sku":"M90","name":"Mouse Logitech M90 Preto Usb","price":44.24,"stock":16},{"sku":"580-AJIT","name":"Conjunto Dell Km5221w Teclado E Mouse","price":250.6,"stock":46},{"sku":"GX40Q17225","name":"Mochila Casual Preta Lenovo 15.6","price":172.0,"stock":6},{"sku":"M280","name":"Mouse Logitech M280 Sem Fio Preto","price":129.87,"stock":2},{"sku":"210-BMGK","name":"Monitor Dell P2425h 24 Full Hd","price":0.0,"stock":6},{"sku":"PRD413683117365856","name":"Webcam Logitech C920s Hd Pro 1080p","price":381.75,"stock":7},{"sku":"80S01A6-E","name":"Headset Hp Poly Blackwire C3210","price":239.04,"stock":19},{"sku":"VVA21P1","name":"Aspirador De Po Vertical 127v","price":162.79,"stock":18}];

const LS_KEY="estoqueos_products";

function genCRSku(n){const s=String(n);const pad=Math.max(4,s.length);return"CR"+s.padStart(pad,"0");}
function assignCRSkus(list){
  const sorted=[...list].sort((a,b)=>a.name.localeCompare(b.name,"pt-BR",{sensitivity:"base"}));
  sorted.forEach((p,i)=>{p.sku_cr=genCRSku(i+1);p.sku_fornecedor=p.sku;p.sku=p.sku_cr;});
  return sorted;
}
function nextCRSku(products){
  const used=new Set(products.map(p=>{const m=p.sku.match(/^CR(\d+)$/);return m?parseInt(m[1]):null;}).filter(n=>n!==null));
  let n=1;while(used.has(n))n++;return genCRSku(n);
}

const CNPJ_ALIAS_MAP={
  "CRO EQUIP":"EQP","CRO TI":"TI","CRO DIST":"DST",
  "ESFERA":"ESF","CFM DIST":"CFM","M.A. DIST":"MA",
  "CRUZEIRO":"CRZ","CRO TECINFO":"TEC","ESPAÇO":"ESP","C.A.S.":"CAS",
};
function genAlias(empresaNome){return CNPJ_ALIAS_MAP[empresaNome?.trim()]||"GEN";}
function genDateStr(){
  const d=new Date();
  return String(d.getDate()).padStart(2,"0")+String(d.getMonth()+1).padStart(2,"0")+String(d.getFullYear());
}
function nextNewSku(products,empresaNome){
  const alias=genAlias(empresaNome);
  const dateStr=genDateStr();
  const re=new RegExp(`^${alias}-${dateStr}-(\\d+)$`);
  const used=new Set(products.map(p=>{const m=p.sku?.match(re);return m?parseInt(m[1]):null;}).filter(n=>n!==null));
  let n=1;while(used.has(n))n++;
  return `${alias}-${dateStr}-${String(n).padStart(5,"0")}`;
}
function buildSeed(){
  const _PMAP={};
  RAW_SEED.forEach(p=>{const k=p.sku.toLowerCase();if(!_PMAP[k]){_PMAP[k]={...p,id:crypto.randomUUID(),sku:p.sku.toUpperCase(),...buildStocks(p.stock,p.sku),movements:[],created_at:new Date().toISOString()};}else{const x=p.stock;_PMAP[k].esfera+=Math.floor(x*0.5);_PMAP[k].croma+=Math.ceil(x*0.5);_PMAP[k].fisico+=x;}});
  return assignCRSkus(Object.values(_PMAP));
}

// ─── localStorage ──────────────────────────────────────────────────────────
function lsLoad(){
  try{const raw=localStorage.getItem(LS_KEY);if(raw){const p=JSON.parse(raw);if(Array.isArray(p)&&p.length>0)return p;}}catch(e){}
  return null;
}
function lsSave(list){
  try{localStorage.setItem(LS_KEY,JSON.stringify(list));}catch(e){}
}

// ─── Supabase — produtos ───────────────────────────────────────────────────
function toRow(p){
  return{
    id:p.id,
    sku:p.sku,
    name:p.name,
    price:p.price??0,
    croma:p.croma??0,
    esfera:p.esfera??0,
    fisico:p.fisico??0,
    min_stock:p.min_stock??3,
    situado:p.endereco??p.situado??null,
    nf_chave:p.nf_chave??null,
    nf_numero:p.nf_numero??null,
    nf_fornecedor:p.nf_fornecedor??null,
    nf_cnpj:p.nf_cnpj_emitente??p.nf_cnpj??null,
    nf_empresa:p.cnpj??p.nf_empresa??null,
    inventario_status:p.inventario_status??null,
    inventario_bloqueado:p.inventario_bloqueado??false,
    ultima_importacao:p.ultima_importacao??null,
    ncm:p.ncm??null,
    unidade:p.unidade??"UN",
    ncodprod_omie:p.ncodprod_omie??null,
  };
}
function fromRow(row,movimentos=[]){
  return{
    ...row,
    endereco:row.situado??'',
    cnpj:row.nf_empresa??'',
    sku_fornecedor:row.sku_fornecedor??row.sku,
    ncm:row.ncm??'',
    unidade:row.unidade??'UN',
    ncodprod_omie:row.ncodprod_omie??null,
    editHistory:[],
    movements:movimentos,
  };
}

async function sbLoad(){
  const[{data:prods,error:pe},{data:movs,error:me}]=await Promise.all([
    supabase.from('produtos').select('*').order('name'),
    supabase.from('movimentacoes').select('*').order('created_at',{ascending:false}),
  ]);
  if(pe||!prods||prods.length===0)return null;
  const movsByProd={};
  (movs||[]).forEach(m=>{
    if(!movsByProd[m.produto_id])movsByProd[m.produto_id]=[];
    movsByProd[m.produto_id].push({
      id:m.id,
      type:m.tipo,
      qty:m.quantidade,
      location:m.deposito_destino,
      from:m.deposito_origem??null,
      to:m.deposito_destino??null,
      operator:m.usuario??'',
      note:m.obs??'',
      date:m.date??m.created_at?.slice(0,10),
      created_at:m.created_at,
    });
  });
  return prods.map(r=>fromRow(r,movsByProd[r.id]??[]));
}

async function sbSeed(seed){
  const rows=seed.map(toRow);
  const{error}=await supabase.from('produtos').insert(rows);
  if(error)console.warn('supabase seed error',error);
}

async function sbUpsertProduct(product){
  const{error}=await supabase.from('produtos').upsert(toRow(product),{onConflict:'sku'});
  if(error)console.warn('supabase upsert error',error);
}
async function forceSyncAllToSupabase(){
  // Garante IDs nos produtos que não têm (imports antigos)
  const needsId=_products.some(p=>!p.id);
  if(needsId){
    _products=_products.map(p=>p.id?p:{...p,id:crypto.randomUUID()});
    lsSave(_products);
    _prl.forEach(f=>f(_products));
  }
  for(const p of _products){
    await sbUpsertProduct(p);
    await new Promise(r=>setTimeout(r,50));
  }
}

// ─── Supabase — movimentações ──────────────────────────────────────────────
async function sbInsertMovimento(produtoId,mv){
  const{error}=await supabase.from('movimentacoes').insert({
    id:mv.id??crypto.randomUUID(),
    produto_id:produtoId,
    tipo:mv.type,
    quantidade:mv.qty,
    deposito_origem:mv.from??null,
    deposito_destino:mv.to??mv.location??null,
    usuario:mv.operator??'',
    obs:mv.note??'',
    date:mv.date??new Date().toISOString().slice(0,10),
  });
  if(error)console.warn('supabase movimentacao insert error',error);
}

// ─── Store global ──────────────────────────────────────────────────────────
let _products=lsLoad()??[];
let _ready=false;
let _prl=[];

function subProducts(fn){_prl.push(fn);return()=>{_prl=_prl.filter(f=>f!==fn);};}

function setGlobalProducts(fn) {
  const prev = _products;
  _products = fn(_products);
  lsSave(_products);
  _prl.forEach(f => f(_products));
  if (_products.length !== prev.length) {
    _products.forEach(p => sbUpsertProduct(p));
  } else {
    _products.forEach((p, i) => {
      if (prev[i] !== p) sbUpsertProduct(p);
    });
  }
}

async function sbDispararAjusteOmie(produtoId, mv) {
  const produto = _products.find(p => p.id === produtoId);
  if (!produto || !produto.ncodprod_omie || !produto.cnpj) return;

  const OMIE_CREDS = {
    'CRO DIST':    { app_key: import.meta.env.VITE_OMIE_KEY_CRO_DIST,    app_secret: import.meta.env.VITE_OMIE_SECRET_CRO_DIST },
    'CRO EQUIP':   { app_key: import.meta.env.VITE_OMIE_KEY_CRO_EQUIP,   app_secret: import.meta.env.VITE_OMIE_SECRET_CRO_EQUIP },
    'CRO TI':      { app_key: import.meta.env.VITE_OMIE_KEY_CRO_TI,      app_secret: import.meta.env.VITE_OMIE_SECRET_CRO_TI },
    'ESFERA':      { app_key: import.meta.env.VITE_OMIE_KEY_ESFERA,      app_secret: import.meta.env.VITE_OMIE_SECRET_ESFERA },
  };

  const creds = OMIE_CREDS[produto.cnpj.trim()];
  if (!creds) {
    console.error(`[OMIE] Empresa '${produto.cnpj}' não possui credenciais no front.`);
    return;
  }

  let qtyAjuste = 0;
  let tipoAjuste = 'ENT';

  if (mv.type === 'ajuste') {
    qtyAjuste = Math.abs(mv.delta);
    tipoAjuste = mv.delta >= 0 ? 'ENT' : 'SAI';
  } else if (mv.type === 'saida') {
    qtyAjuste = Math.abs(mv.qty);
    tipoAjuste = 'SAI';
  } else {
    qtyAjuste = Math.abs(mv.qty);
    tipoAjuste = 'ENT';
  }

  const custoUnitario = produto.price > 0 ? produto.price : 1.00;

  const payload = {
    call: 'IncluirAjusteEstoque',
    app_key: creds.app_key,
    app_secret: creds.app_secret,
    param: [{
      id_prod: parseInt(produto.ncodprod_omie),
      data: new Date().toLocaleDateString('pt-BR'),
      quan: qtyAjuste,
      valor: custoUnitario,
      tipo: tipoAjuste,
      obs: mv.note || "Ajuste via EstoqueOS"
    }]
  };

  try {
    const token = import.meta.env.VITE_SUPABASE_ANON_KEY;
    const resp = await fetch('https://jjndzkkwheixsdeizwsr.supabase.co/functions/v1/omie-proxy', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ endpoint: 'estoque/ajuste', payload: payload })
    });

    const data = await resp.json();
    if (data.faultstring) {
      console.error("[OMIE] Erro ao ajustar estoque:", data.faultstring);
      const { logEvent } = await import('./eventLog.js');
      logEvent({
        tipo_evento: "OMIE_AJUSTE_ERRO",
        usuario: "Sistema",
        entidade: "PRODUTO",
        id_entidade: String(produtoId),
        detalhes: `Empresa: ${produto.cnpj} | ncodprod: ${produto.ncodprod_omie} | Erro: ${data.faultstring}`,
      });
    }
  } catch (e) {
    console.error("[OMIE] Falha de comunicação:", e);
    const { logEvent } = await import('./eventLog.js');
    logEvent({
      tipo_evento: "OMIE_AJUSTE_ERRO",
      usuario: "Sistema",
      entidade: "PRODUTO",
      id_entidade: String(produtoId),
      detalhes: `Empresa: ${produto.cnpj} | Falha de rede: ${e.message}`,
    });
  }
}

// saveMovimento — persiste no Supabase E atualiza o produto em memória
function saveMovimento(produtoId, mv, updaterFn) {
  sbInsertMovimento(produtoId, mv);
  setGlobalProducts(all => all.map(p => p.id === produtoId ? updaterFn(p) : p));
  sbDispararAjusteOmie(produtoId, mv);
}

async function initProducts() {
  if(_ready)return;
  _ready=true;
  const remote=await sbLoad();
  if(remote&&remote.length>0){
    _products=remote;
    lsSave(_products);
    _prl.forEach(f=>f(_products));
    return;
  }
  if(_products.length===0)_products=buildSeed();
  await sbSeed(_products);
  lsSave(_products);
  _prl.forEach(f=>f(_products));
}

function useGlobalProducts() {
  const[p,sP]=useState(()=>_products);
  useEffect(()=>{
    sP(_products);
    const unsub=subProducts(sP);
    initProducts();
    return unsub;
  },[]);
  return[p,setGlobalProducts];
}

async function sbAtualizarProdutoOmie(produto, fields) {
  if (!produto.ncodprod_omie || !produto.cnpj) return;

  const OMIE_CREDS = {
    'CRO DIST':    { app_key: import.meta.env.VITE_OMIE_KEY_CRO_DIST,    app_secret: import.meta.env.VITE_OMIE_SECRET_CRO_DIST },
    'CRO EQUIP':   { app_key: import.meta.env.VITE_OMIE_KEY_CRO_EQUIP,   app_secret: import.meta.env.VITE_OMIE_SECRET_CRO_EQUIP },
    'CRO TI':      { app_key: import.meta.env.VITE_OMIE_KEY_CRO_TI,      app_secret: import.meta.env.VITE_OMIE_SECRET_CRO_TI },
    'ESFERA':      { app_key: import.meta.env.VITE_OMIE_KEY_ESFERA,      app_secret: import.meta.env.VITE_OMIE_SECRET_ESFERA },
    'CFM DIST':    { app_key: import.meta.env.VITE_OMIE_KEY_CFM_DIST,    app_secret: import.meta.env.VITE_OMIE_SECRET_CFM_DIST },
    'M.A. DIST':   { app_key: import.meta.env.VITE_OMIE_KEY_MA_DIST,     app_secret: import.meta.env.VITE_OMIE_SECRET_MA_DIST },
    'CRUZEIRO':    { app_key: import.meta.env.VITE_OMIE_KEY_CRUZEIRO,    app_secret: import.meta.env.VITE_OMIE_SECRET_CRUZEIRO },
    'CRO TECINFO': { app_key: import.meta.env.VITE_OMIE_KEY_CRO_TECINFO, app_secret: import.meta.env.VITE_OMIE_SECRET_CRO_TECINFO },
    'ESPACO':      { app_key: import.meta.env.VITE_OMIE_KEY_ESPACO,      app_secret: import.meta.env.VITE_OMIE_SECRET_ESPACO },
    'C.A.S.':      { app_key: import.meta.env.VITE_OMIE_KEY_CAS,         app_secret: import.meta.env.VITE_OMIE_SECRET_CAS },
  };

  const creds = OMIE_CREDS[produto.cnpj.trim()];
  if (!creds || !creds.app_key) return;

  const nameChanged  = fields.name  !== undefined && fields.name  !== produto.name;
  const priceChanged = fields.price !== undefined && fields.price !== produto.price;
  if (!nameChanged && !priceChanged) return;

  const param = {
    codigo_produto_integracao: produto.sku,
    codigo_produto: parseInt(produto.ncodprod_omie),
  };
  if (nameChanged)  param.descricao      = fields.name.substring(0, 100);
  if (priceChanged) param.valor_unitario = fields.price > 0 ? fields.price : 1.00;

  try {
    const token = import.meta.env.VITE_SUPABASE_ANON_KEY;
    const resp = await fetch('https://jjndzkkwheixsdeizwsr.supabase.co/functions/v1/omie-proxy', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify({
        endpoint: 'geral/produtos',
        payload: { call: 'AlterarProduto', app_key: creds.app_key, app_secret: creds.app_secret, param: [param] }
      })
    });
    const data = await resp.json();
    if (data.faultstring) {
      console.error('[OMIE] Erro ao alterar produto:', data.faultstring);
      const { logEvent } = await import('./eventLog.js');
      logEvent({ tipo_evento:'OMIE_PRODUTO_ERRO', usuario:'Sistema', entidade:'PRODUTO', id_entidade:produto.sku, detalhes:`AlterarProduto falhou: ${data.faultstring}` });
    }
  } catch(e) {
    console.error('[OMIE] Falha ao alterar produto:', e);
  }
}

export {useGlobalProducts,nextNewSku, setGlobalProducts, saveMovimento, nextCRSku, sbDispararAjusteOmie, sbAtualizarProdutoOmie, forceSyncAllToSupabase }